import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ShipmentStatusState {
  no_of_days: string;
  refetchChart: boolean;
}

export const initialState: ShipmentStatusState = {
  no_of_days: "6",
  refetchChart: false,
};

export const shipmentStatusSlice = createSlice({
  name: "shipmentStatus",
  initialState,
  reducers: {
    changeNoOfDays: (
      state: ShipmentStatusState,
      action: PayloadAction<string>
    ) => {
      state.no_of_days = action.payload;
    },
    changeRefetchChart: (
      state: ShipmentStatusState,
      action: PayloadAction<boolean>
    ) => {
      state.refetchChart = action.payload;
    },
  },
});

export const { changeNoOfDays, changeRefetchChart } =
  shipmentStatusSlice.actions;
